export default __webpack_public_path__ + "static/media/EM0920.34I-23055_-15250_0.b42372d7.jpg";